import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HoldBreakdownData } from './hold-breakdown.model';

/**
 * #124: shared, presentational drill-down body for a Balance-on-Hold bucket.
 *
 * Renders title + count badge, the item rows, an outbound link and a dismiss
 * control — driven entirely by a single
 * {@link HoldBreakdownData} input. It is container-agnostic: the SAME component
 * is projected into the desktop anchored popover and the mobile bottom-sheet
 * modal (the responsive opener in WalletComponent picks the container by
 * viewport breakpoint). It owns no data fetching and no breakpoint logic.
 *
 * `dismiss` / `navigate` are emitted up so each container can close itself the
 * right way (popover.close() vs modal.dismiss()) and route via the host's Router.
 */
@Component({
  selector: 'app-hold-breakdown-content',
  templateUrl: './hold-breakdown-content.component.html',
  styleUrls: ['./hold-breakdown-content.component.scss'],
  standalone: false,
})
export class HoldBreakdownContentComponent {
  @Input() data: HoldBreakdownData;

  /** Emitted when the user hits the close (×) control. */
  @Output() dismiss = new EventEmitter<void>();

  /** Emitted (with the router commands) when the outbound link is clicked. */
  @Output() navigate = new EventEmitter<any[]>();

  onDismiss(): void {
    this.dismiss.emit();
  }

  onNavigate(): void {
    if (this.data?.linkAction) {
      this.data.linkAction();
      this.dismiss.emit();
      return;
    }
    this.navigate.emit(this.data?.linkCommands ?? []);
  }
}
